var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnergy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3974 3.74248C16.6278 3.20734 16.456 2.58236 15.9834 2.23863C15.5109 1.89489 14.8665 1.92614 14.4251 2.30894L4.42731 11.0586C4.03677 11.4024 3.89617 11.9531 4.07973 12.4375C4.26328 12.9218 4.73193 13.25 5.25135 13.25H9.60588L6.60262 20.2575C6.3722 20.7927 6.54404 21.4176 7.01659 21.7614C7.48915 22.1051 8.13354 22.0739 8.57485 21.6911L18.5727 12.9414C18.9632 12.5976 19.1038 12.0469 18.9203 11.5625C18.7367 11.0782 18.272 10.754 17.7487 10.754H13.3941L16.3974 3.74248Z",
    fill: "#171717",
    fillOpacity: 0.87
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergy);
export default __webpack_public_path__ + "static/media/energy.c8af64f031520bfffa4d14491285456c.svg";
export { ForwardRef as ReactComponent };